<div class="note-selector">
  <h4>Releases</h4>

  @for (note of releaseNotes(); track note.released.format()) {
    <div class="version-info"
         [class.selected-note]="note === activeNote"
         (click)="setActiveNote(note)"
         tabindex="0"
         (keyup.enter)="setActiveNote(note)">
      <span>Version {{ note.majorVersion }}.{{ note.minorVersion }} </span>
    </div>
  }

</div>
<div class="active-release-note">

  <h1>Release Notes</h1>

  <p>We encourage your feedback anytime on any bugs or other suggestions by contacting the TASTI-GRID team at <a
    href="mailto:tastigrid@ornl.gov">tastigrid&#64;ornl.gov</a> or  using the 'Provide Feedback' option under
    the user icon.</p>

  @if (activeNote) {


    <h2>Version {{ activeNote.majorVersion }}.{{ activeNote.minorVersion }}</h2>

    <h3 >{{ activeNote.released.toDate() | date : 'longDate' }}</h3>



    <div [innerHTML]="activeNote.notes | sanitize" class="release-details"></div>
  }
</div>

